/**
 * ShortProductKey is used in code. It should not have a special characters or empty space
 */
export let ShortProductKey = /*#__PURE__*/function (ShortProductKey) {
  ShortProductKey["CONFLUENCE"] = "confluence";
  ShortProductKey["JIRA"] = "jira";
  ShortProductKey["JIRA_CORE"] = "jira_core";
  ShortProductKey["JIRA_SOFTWARE"] = "jira_software";
  ShortProductKey["JIRA_SERVICE_DESK"] = "jira_service_key";
  ShortProductKey["BITBUCKET"] = "bitbucket";
  return ShortProductKey;
}({});

/**
 * ProductName is used to render in UI.
 * This page (https://www.atlassian.com/software) lists some Atlassian product names.
 */
export let ProductName = /*#__PURE__*/function (ProductName) {
  ProductName["CONFLUENCE"] = "Confluence";
  ProductName["JIRA"] = "Jira";
  ProductName["JIRA_CORE"] = "Jira Core";
  ProductName["JIRA_SOFTWARE"] = "Jira Software";
  ProductName["JIRA_SERVICE_DESK"] = "Jira Service Desk";
  ProductName["BITBUCKET"] = "Bitbucket";
  ProductName["TEAM_CENTRAL"] = "Team Central";
  ProductName["ATLAS"] = "Atlas";
  ProductName["HOME"] = "Atlassian Home";
  return ProductName;
}({});

// Passed in from Jira to the People Directory.

// product names which accepts by pf-directory service

export const mapProductNameToDirectoryProduct = {
  [ProductName.JIRA]: 'JIRA',
  [ProductName.CONFLUENCE]: 'CONFLUENCE',
  [ProductName.TEAM_CENTRAL]: 'TOWNSQUARE',
  [ProductName.ATLAS]: 'TOWNSQUARE',
  [ProductName.HOME]: 'HOME'
};

// when querying Sites from some services, these are product keys the back-end returns
export let LongProductKey = /*#__PURE__*/function (LongProductKey) {
  LongProductKey["JIRA_CORE"] = "jira-core.ondemand";
  LongProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
  LongProductKey["CONFLUENCE"] = "confluence.ondemand";
  LongProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
  LongProductKey["BITBUCKET"] = "bitbucket";
  return LongProductKey;
}({});

// There is no user custom product icon or product display name, so
// product icon and product name is fixed